import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { GetSubscriptionUsers } from "../../../Api/subscription";
import { ErrorToast } from "../../../Utils/SweetAlert";

const formatDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

const UserTab = ({ filters = {}, page = 0, rowsPerPage = 10, onLoaded }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const params = useMemo(() => ({
    page: page === 0 ? 1 : page + 1,
    limit: rowsPerPage,
    search: filters?.search || "",
    planType: filters?.planType && filters.planType !== 'all' ? filters.planType : undefined,
    ...(filters?.startDate ? { startDate: filters.startDate } : {}),
    ...(filters?.endDate ? { endDate: filters.endDate } : {}),
  }), [page, rowsPerPage, filters]);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await GetSubscriptionUsers(params);
      const payload = response?.data || {};
      setItems(payload?.data || []);
      setTotal(payload?.totalRecords || 0);
      onLoaded && onLoaded({ 
        total: payload?.totalRecords || 0,
        totals: payload?.totals || null,
      });
    } catch (error) {
      ErrorToast(error?.response?.data?.message || "Server Error.")
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [params]);

  return (
    <div className="cards-table card-table">
      <div className="card-body">
        <div className="table-responsive custom-pagination">
          <table className="table datatable table-manager mb-0 table-no-padding" style={{ width: '100%' }}>
            <thead className="thead-light">
              <tr>
                <th className="text-start">Name</th>
                <th className="text-start">Email</th>
                <th className="text-start">Plan Type</th>
                <th className="text-start">Payment Method</th>
                <th className="text-start">Start Date</th>
                <th className="text-start">End Date</th>
              </tr>
            </thead>
            <tbody>
              {isLoading && (
                <tr>
                  <td align="center" colSpan={6}>
                    <div className="d-flex justify-content-center align-items-center py-4">
                      <div className="spinner-border loader-theme" role="status" />
                    </div>
                  </td>
                </tr>
              )}
              {!isLoading && items?.length === 0 && (
                <tr>
                  <td className="text-center" colSpan={6}>No Records Found.</td>
                </tr>
              )}
              {!isLoading &&items?.map((row) => (
                <tr key={row?._id}>
                  <td className="text-start">
                    {row?._id ? (
                      <Link className="subscription-neutral-link" to="/admin/client-user-detail" state={{ id: row?._id }}>
                        {row?.name || '-'}
                      </Link>
                    ) : (row?.name || '-')}
                  </td>
                  <td className="text-start">{row?.email || '-'}</td>
                  <td className="text-capitalize">{row?.subscriptionPlanType || '-'}</td>
                  <td className="text-capitalize">{row?.subscription?.isCashSubscription ? "cash" : "stripe" || '-'}</td>
                  <td className="text-start">{formatDate(row?.subscription?.startDate)}</td>
                  <td className="text-start">{formatDate(row?.subscription?.endDate)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserTab;


